export default __webpack_public_path__ + "static/media/configr-mail-negative.f987aa83.svg";